const HIDEABLE_OVERLAYS = [
  '.ant-popover',
  '.ant-dropdown',
  '.ant-select-dropdown',
  '.ant-picker-dropdown',
  '.ant-cascader-dropdown',
];

const isHiddenByClass = (element: Element) =>
  Array.from(element.classList).some((className) => className.endsWith('-hidden'));

/**
 * Overlays close themselves on Escape, so a screen-level Escape must leave the key to them. A
 * closed antd overlay stays in the DOM, hidden by a class (popups) or by its wrapper's inline
 * display (modals).
 */
export const hasOpenOverlay = (root: ParentNode = document) => {
  const hasOpenPopup = HIDEABLE_OVERLAYS.some((selector) =>
    Array.from(root.querySelectorAll(selector)).some((element) => !isHiddenByClass(element)),
  );
  const hasOpenModal = Array.from(root.querySelectorAll<HTMLElement>('.ant-modal-wrap')).some(
    (wrapper) => wrapper.style.display !== 'none',
  );
  return hasOpenPopup || hasOpenModal;
};

/** A focused toast takes Escape to dismiss itself. */
export const isInToastRegion = (target: EventTarget | null) =>
  target instanceof Element && !!target.closest('.Toastify');
